import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'setColorByIndex'
})
export class SetColorByIndexPipe implements PipeTransform {

  transform(value: number): string {
    const colors = [
      '#f3a683',
      '#f7d794',
      '#778beb',
      '#e77f67',
      '#cf6a87',
      '#f19066',
      '#f5cd79',
      '#546de5',
      '#e15f41',
      '#c44569',
      '#786fa6',
      '#f8a5c2',
      '#63cdda',
      '#ea8685',
      '#574b90',
      '#f78fb3',
      '#3dc1d3',
      '#e66767',
      '#D6A2E8',
      '#BDC581',
      '#FC427B'
    ];
    return colors[value];
  }

}
